// const BASE_URL = 'http://3.21.244.222:4000/api';
// const BASE_URL = 'http://3.148.254.56:4000/api'; // new assigned IP
const BASE_URL = 'https://api.olaitools.com/api';
// const BASE_URL = 'http://localhost:4000/api';



export const fetchLtiSessionInfo = async () => {
    try {
        const response = await fetch(`${BASE_URL}/dashboard/lti-session-info`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch LTI session info');
        }
        
        const data = await response.json();
        console.log('Front - API - overviewApi - LTI session info data:', data);
        return data;
    } catch (error) {
        console.error("Error fetching LTI session info:", error);
        throw error;
    }
}

export const fetchSubmissionStats = async (start, end, courseId) => {
    console.log("overviewApi - fetchSubmissionStats - start, end, courseId:", start, end, courseId);
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }
        if (courseId) {
            params.append('courseId', courseId);
        }

        const endpoint = `${BASE_URL}/dashboard/course-submission-stats`;
        
        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch submission stats');
        }

        const data = await response.json();
        // expect: { submissionCount: number, respondentCount: number }
        const submissionCount = data.submissionCount || 0;
        const respondentCount = data.respondentCount || 0;
        console.log('Front - API - overviewApi - Submission stats:', { submissionCount, respondentCount });
        return { submissionCount, respondentCount };
    } catch (error) {
        console.error("Error fetching submission stats:", error);
        throw error;
    }
};


export const fetchSubmissionCount = async (start, end, courseId) => {
    console.log("overviewApi - fetchSubmissionCount - start, end, courseId:", start, end, courseId);
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }
        if (courseId) {
            params.append('courseId', courseId);
        }

        const endpoint = courseId
            ? `${BASE_URL}/dashboard/course-submission-count`
            : `${BASE_URL}/dashboard/demo-submission-count`;

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch submission count');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Submission count:', data);
        return data;
    } catch (error) {
        console.error("Error fetching submission count:", error);
        throw error;
    }
};
export const fetchDemoSubmissionCount = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-submission-count${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo submission count');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching demo submission count:", error);
        throw error;
    }
};

export const fetchQuestionAverageByQuiz = async (courseId, sectionNumber = null) => {
    console.log("overviewApi - fetchQuestionAverageByQuiz - courseId, sectionNumber:", courseId, sectionNumber);
    try {
        const params = new URLSearchParams();
        let endpoint;

        if (courseId) {
            params.append("courseId", courseId);
            endpoint = `${BASE_URL}/dashboard/course-question-average-by-quiz`;
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-question-average`;
        }

        if (sectionNumber && sectionNumber !== "all") {  // ← add
            params.append("sectionNumber", sectionNumber);
        }

        const response = await fetch(
            `${endpoint}?${params.toString()}`,
            { credentials: "include" }
        );

        if (!response.ok) {
            throw new Error("Failed to fetch course question average");
        }

        const data = await response.json();
        console.log("Front - API - overviewApi - Course question average:", data);

        // normalize the shape for frontend use
        return (data.quizzes || data).map((row) => ({
            canvasCourseId: row.canvas_course_id,
            quizId: row.quiz_id,
            quizTitle: row.quiz_title,   // <- keep quiz_title
            groupCode: row.group_code,
            avgScore: Number(row.avg_score),
            minScore: Number(row.min_score),
            maxScore: Number(row.max_score),
            stdDev: Number(row.std_dev),
            n: Number(row.n),
        }));
    } catch (error) {
        console.error("Error fetching course question average:", error);
        throw error;
    }
};

export const fetchQuestionAverage = async (start, end, courseId, sectionNumber = null) => {
    console.log("overviewApi - fetchQuestionAverage - start, end, courseId, sectionNumber:", start, end, courseId, sectionNumber);
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }

        if (sectionNumber && sectionNumber !== 'all') {
            params.append('sectionNumber', sectionNumber);
        }

        let endpoint;                                                           
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/course-question-average`;     
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-question-average`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch course question average');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Course question average:', data);
        return data;
    } catch (error) {
        console.error("Error fetching course question average:", error);
        throw error;
    }
};
export const fetchDemoQuestionAverage = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-question-average${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo question average');
        }
        const data = await response.json();
        console.log('Front - API - overviewApi - Demo question average:', data);
        return data;
    } catch (error) {
        console.error("Error fetching demo question average:", error);
        throw error;
    }
};

export const fetchAllSubmissionDates = async (courseId) => {
    console.log("overviewApi - fetchAllSubmissionDates - courseId:", courseId); 
    try {
        const params = new URLSearchParams();
        let endpoint;

        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/all-course-submission-dates`;
        } else {
            endpoint = `${BASE_URL}/dashboard/all-demo-submission-dates`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch submission dates');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Submission dates:', data);
        return data;
    } catch (error) {
        console.error("Error fetching submission dates:", error);
        throw error;
    }
};
export const fetchAllDemoSubmissionDates = async () => {
    try {
        const response = await fetch(`${BASE_URL}/dashboard/all-demo-submission-dates`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch demo submission dates');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Demo submission dates:', data);
        return data;
    } catch (error) {
        console.error("Error fetching demo submission dates:", error);
        throw error;
    }
};

// export const fetchClickTimeRange = async (start, end, courseId) => {
export const fetchClickTimeRange = async (courseId) => {
    // console.log("overviewApi - fetchClickTimeRange - start, end, courseId:", start, end, courseId);
    console.log("overviewApi - fetchClickTimeRange - courseId:", courseId);
    try {
        const params = new URLSearchParams();
        // if (start && end) {
        //     params.append('start', start);
        //     params.append('end', end);
        // }

        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/click-timerange-course`;
        } else {
            endpoint = `${BASE_URL}/dashboard/click-timerange`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch click time range');
        }

        const data = await response.json();
        console.log("Click time range", data);
        return data;
    } catch (error) {
        console.error("Error fetching click time range:", error);
        throw error;
    }
};
export const fetchDemoClickTimeRange = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/click-timerange${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo click time range');
        }
        const data = await response.json();
        console.log("Demo click time range", data);
        return data;
    } catch (error) {
        console.error("Error fetching demo click time range:", error);
        throw error;
    }
}

export const fetchStudentCount = async (courseId) => {
    console.log("overviewApi - fetchStudentCount - courseId:", courseId);
    try {
        const params = new URLSearchParams();

        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/course-student-count`;
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-student-count`;
        }
        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch user count');
        }

        const data = await response.json();
        console.log("User count:", data);
        return data;
    } catch (error) {
        console.error("Error fetching user count:", error);
        throw error;
    }
};

export const fetchCourseName = async (courseId) => {
    console.log("overviewApi - fetchCourseName - courseId:", courseId);
    if (!courseId) {
        throw new Error('Course ID is required to fetch course name');
    }
    try {
        console.log("Fetching course name for courseId:", courseId);
        const response = await fetch(`${BASE_URL}/dashboard/course-name?courseId=${encodeURIComponent(courseId)}`, {
            credentials: 'include'
        });
        console.log("Response from course name endpoint:", response);

        if (!response.ok) {
            throw new Error('Failed to fetch course name');
        }

        const data = await response.json();
        console.log("Course name:", data.course);
        const course = data.course || {};
        return course.name || "Unknown Course";
    }
    catch (error) {
        console.error("Error fetching course name:", error);
        throw error;
    }
};

export const fetchOnboardingStatus = async (courseId) => {
    console.log("overviewApi - fetchOnboardingStatus - courseId:", courseId);
    if (!courseId) {
        throw new Error('Course ID is required to fetch onboarding status');
    }
    try {
        const response = await fetch(`${BASE_URL}/onboarding/status?courseId=${encodeURIComponent(courseId)}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch onboarding status');
        }
        const data = await response.json();
        console.log("Onboarding status:", data);
        return data;
    } catch (error) {
        console.error("Error fetching onboarding status:", error);
        throw error;
    }
};

// GET /api/onboarding/survey-weeks?startWeek=2026-09-14 (startWeek optional)
export const fetchSurveyWeeks = async (startWeek) => {
    console.log("overviewApi - fetchSurveyWeeks - startWeek:", startWeek);
    const url = startWeek
        ? `${BASE_URL}/onboarding/survey-weeks?startWeek=${encodeURIComponent(startWeek)}`
        : `${BASE_URL}/onboarding/survey-weeks`;
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Failed to fetch survey weeks");
    }
    return res.json();
};

export const postOnboardingPage1 = async (courseId) => {
    console.log("overviewApi - postOnboardingPage1 - courseId:", courseId);
    if (!courseId) {
        throw new Error('Course ID is required to post onboarding page 1');
    }
    try {
        const response = await fetch(`${BASE_URL}/onboarding/page1`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ courseId }),
        });
        if (!response.ok) {
            throw new Error('Failed to post onboarding page 1');
        }
        const data = await response.json();
        console.log("Onboarding page 1 response:", data);
        return data;
    } catch (error) {
        console.error("Error posting onboarding page 1:", error);
        throw error;
    }
};

export const postOnboardingPage2 = async (courseId) => {
    console.log("overviewApi - postOnboardingPage2 - courseId:", courseId);
    if (!courseId) {
        throw new Error('Course ID is required to post onboarding page 2');
    }
    try {
        const response = await fetch(`${BASE_URL}/onboarding/page2`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ courseId }),
        });
        if (!response.ok) {
            throw new Error('Failed to post onboarding page 2');
        }
        const data = await response.json();
        console.log("Onboarding page 2 response:", data);
        return data;
    } catch (error) {
        console.error("Error posting onboarding page 2:", error);
        throw error;
    }
};

// POST /api/onboarding/activate
// Body: { courseId, notify, startWeek, endWeek }
export const postOnboardingActivate = async (courseId, notify, startWeek, endWeek) => {
    console.log("overviewApi - postOnboardingActivate - courseId, notify, startWeek, endWeek:", courseId, notify, startWeek, endWeek);
    if (!courseId) {
        throw new Error('Course ID is required to post onboarding activation');
    }
    try {
        const response = await fetch(`${BASE_URL}/onboarding/activate`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ courseId, notify, startWeek, endWeek }),
        });
        if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.error || "Failed to activate onboarding");
        }
        const data = await response.json();
        console.log("Onboarding activation response:", data);
        return data;
    } catch (error) {
        console.error("Error posting onboarding activation:", error);
        throw error;
    }
};

export const fetchCourseSections = async (courseId) => {
    console.log("overviewApi - fetchCourseSections - courseId:", courseId);
    try {
        const params = new URLSearchParams();
        if (courseId) {
            params.append('courseId', courseId);
        }

        const response = await fetch(`${BASE_URL}/dashboard/course-sections?${params.toString()}`, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch course sections');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Course sections:', data);
        return data;
    } catch (error) {
        console.error("Error fetching course sections:", error);
        throw error;
    }
};

export const postDeployQuizzes = async (courseId) => {
    if (!courseId) {
        throw new Error('Course ID is required to deploy quizzes');
    }
    try {
        const response = await fetch(`${BASE_URL}/onboarding/deploy`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ courseId }),
        });
        if (!response.ok) {
            throw new Error('Failed to deploy quizzes');
        }
        const data = await response.json();
        console.log("Quiz deploy response:", data);
        return data;
    } catch (error) {
        console.error("Error deploying quizzes:", error);
        throw error;
    }
};

export const fetchCourseStatus = async (courseId) => {
    if (!courseId) {
        throw new Error('Course ID is required to fetch course status');
    }
    try {
        const response = await fetch(`${BASE_URL}/dashboard/course-status/${courseId}`, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch course status');
        }
        const data = await response.json();
        console.log("Course status response:", data);
        return data;
    } catch (error) {
        console.error("Error fetching course status:", error);
        throw error;
    }
};
